import React, { useContext } from "react";
import MyContext from "../../../StoreContext";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const responses = {
  max: "El monto máximo para transferencias es de 500.000.- pesos diarios. En el caso de querer modificar este límite comuniquese con su ejecutivo al teléfono 800200188s.",
  blockcard:
    "Hola, con gusto te ayudamos. Puedes bloquear tu tarjeta por el tiempo que quieras siguiendo estos pasos: Ingresa al APP > Tarjetas > Seleccionar Tarjeta > Bloquear Tarjeta > Confirmar bloqueo temporal...",
  consult: "respuesta consult",
  extension:
    "La prórroga puede ser solicitada dentro de los primeros 60 días contados desde la fecha de prestación, siempre y cuando la responsabilidad por la tardanza del envío de los gastos...",
  include:
    "Junto con saludar, le informo que todo trámite de incorporación tanto de titular como de sus beneficiarios debe ser canalizado directamente con el área de RR.HH. de la empresa en que trabaja...",
  claim:
    "Hola, te pedimos disculpas por las molestias ocasionadas. Por favor indícanos el número de orden y RUT del cliente para consultar si tienes un reclamo ingresado. Si no tienes un reclamo en nuestro sistema, crearemos uno y un ejecutivo se encargará de dar respuesta a tu problema lo antes posible.",
  address:
    "Hola, para modificar los datos de tu orden por favor indícanos el número de orden y RUT del cliente. Si quieres cambiar la dirección de despacho, por favor indícanos la nueva dirección. Nos comunicaremos contigo para avisarte si aún es posible hacer un cambio.",
};

const autoResponseContainer = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "center",
  width: "220px",
  background: "#F6FBFE",
  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
  borderRadius: "15px",
  padding: "16px",
};

const responseTitle = {
  fontSize: "18px",
  fontWeight: "600",
  fontFamily: "Asap",
  color: "#000000",
  lineHeight: "20px",
};

const responseStyle = {
  fontSize: "14px",
  fontWeight: "500",
  fontFamily: "Asap",
  color: "#000000",
  textAlign: "left",
  marginTop: "8px",
};

/**
 * Componente que muestra la respuesta indicada segun el mensajes
 * seleccionado usando el json response que aqui definimos
 */
const AutoResponse = () => {
  const { message } = useContext(MyContext);

  return (
    <Grid sx={autoResponseContainer}>
      {/* <h5 style={{ fontSize: "18px" }}>Respuesta automatica:</h5> */}
      <Typography sx={responseTitle}>Respuesta automatica:</Typography>
      <Typography sx={responseStyle}>
        {message === "stolen" || message === "order" || message === "consult"
          ? "N/A"
          : `${responses[message as keyof typeof responses]}`}
      </Typography>
    </Grid>
  );
};

export default AutoResponse;
